export default __webpack_public_path__ + "static/media/napaProgramsLogo_fr.42cd4974.svg";